import * as React from 'react'
import styles from './styles.module.css'

export function SideBarContent({ children }: React.PropsWithChildren) {
  return (
    <div
      className={
        styles.sideBarContent
      }
    >
      {children}
    </div>
  )
}
